<template>
  <div class="buy-dialog-wrapper">
    <CustomDialog
      v-model="dialog"
      ref="customDialog"
      :width="500"
      :loading="loading.submit"
      :title="_title"
      hideFooter
      @cancel="handleCloseDialog()"
    >
      <div v-if="dialog" class="mt-n4">
        <v-window v-if="item" v-model="step" :touchless="true">
          <v-window-item :value="1" class="pa-0">
            <v-row align="center" justify="center">
              <v-col cols="8" sm="6">
                <v-img
                  :src="item.image"
                  class="rounded-xl"
                  contain
                  :aspect-ratio="4 / 4"
                />
              </v-col>

              <v-col cols="12">
                <div class="mb-1">
                  <div class="d-flex align-center text-h6">
                    <v-tooltip
                      v-if="item.itemType === 'draw'"
                      color="black"
                      :open-on-click="false"
                      bottom
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="mr-2"
                          color="neutral8"
                          icon
                          small
                          @click="handleRarityDialog()"
                        >
                          <v-icon>mdi-information-outline</v-icon>
                        </v-btn>
                      </template>

                      <span>Premiações disponíveis</span>
                    </v-tooltip>

                    <span>
                      {{ item.name }}
                    </span>

                    <v-spacer /> R$
                    {{ currencyMask(item.value) }}
                  </div>

                  <div
                    v-if="_itemCount > 0 && item.itemType === 'booster'"
                    class="d-flex text-body-2 neutral8--text"
                  >
                    <span> +{{ _itemCount }} números </span>

                    <v-spacer />

                    R$
                    {{
                      currencyMask(
                        formatAmount(item.value / item.effects.multiplier, 2, 2)
                      )
                    }}
                    por número
                  </div>
                </div>

                <div
                  v-if="item.points > 0"
                  class="d-flex align-center text-body-2"
                >
                  <span class="neutral8--text"> Saldo de pontos: </span>

                  <v-icon color="pointColor" size="1.125rem">
                    mdi-cards-diamond
                  </v-icon>
                  {{ _user?.profile?.points }}
                </div>

                <div
                  v-if="item.value > 0"
                  class="d-flex align-center text-body-2 mb-2"
                >
                  <span class="neutral8--text"> Minha carteira: </span>
                  <span class="currencyColor--text mx-1"> R$ </span>

                  {{ currencyMask(_user?.wallet?.balance) }}
                </div>

                <section v-if="promotions.length" class="mb-2">
                  <v-card
                    v-for="(item, i) in promotions"
                    :key="i"
                    class="card rounded-lg pa-1 mb-1"
                    color="amber"
                  >
                    <div
                      class="black--text font-weight-bold text-subtitle-1 text-center promotion-description"
                    >
                      {{ item.description }}
                    </div>
                  </v-card>
                </section>

                <v-card class="rounded-xl mb-1" color="neutral2">
                  <div class="d-flex align-center">
                    <v-btn
                      color="neutral4"
                      :disabled="loading.submit || quantity <= 0"
                      depressed
                      rounded
                      @click="decrease()"
                    >
                      <v-icon>mdi-minus</v-icon>
                    </v-btn>

                    <v-spacer />

                    <span class="text-h6 fill-width">
                      <input
                        v-model.number="quantity"
                        class="quantity-input"
                        type="number"
                        min="1"
                        @keypress="preventOnlyNumber"
                      />
                    </span>

                    <v-spacer />

                    <v-btn
                      color="neutral4"
                      :disabled="loading.submit"
                      depressed
                      rounded
                      @click="increase()"
                    >
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </div>
                </v-card>

                <div v-if="!valid" class="text-body-2 red--text">
                  <span v-if="!quantity">
                    Informe uma quantidade superior à 0
                  </span>
                </div>

                <v-chip-group class="mb-4" column>
                  <v-chip
                    v-for="(item, i) in suggestions"
                    :key="i"
                    :disabled="loading.submit"
                    outlined
                    dense
                    @click="setSuggestion(item)"
                  >
                    +{{ item }}
                  </v-chip>
                </v-chip-group>

                <section v-if="item.value > 0" class="mb-3">
                  <div
                    class="d-flex flex-column flex-md-row fill-width text-body-2"
                  >
                    <div class="neutral8--text" style="min-width: 10rem">
                      Método de pagamento:
                    </div>

                    <v-spacer />

                    <div class="d-flex flex-column fill-width">
                      <div v-if="item.points > 0" class="d-flex fill-width">
                        Pontos

                        <v-spacer />

                        <span
                          :class="
                            _totalPoints > _user?.profile?.points
                              ? 'error--text'
                              : 'pointColor--text'
                          "
                        >
                          -
                          <v-icon
                            :color="
                              _totalPoints > _user?.profile?.points
                                ? 'error'
                                : 'pointColor'
                            "
                            size="1.125rem"
                          >
                            mdi-cards-diamond
                          </v-icon>
                          {{ currencyMask(_totalPoints) }}
                        </span>
                      </div>

                      <div v-if="item.value > 0" class="d-flex fill-width mb-2">
                        Minha carteira

                        <v-spacer />

                        <span class="primary--text">
                          - R$
                          {{
                            currencyMask(
                              _finalPrice <= 0
                                ? _totalPrice
                                : _user?.wallet?.balance
                            )
                          }}
                        </span>
                      </div>

                      <div v-if="_finalPrice > 0" class="d-flex fill-width">
                        Pix

                        <v-spacer />

                        <span
                          :class="
                            _finalPrice < 5 ? 'red--text' : 'primary--text'
                          "
                        >
                          R$ {{ currencyMask(_finalPrice) }}</span
                        >
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="_finalPrice > 0 && _finalPrice < 5"
                    class="red--text text-caption text-right"
                  >
                    Valor mínimo para transação PIX é de R$ 5,00
                  </div>
                </section>

                <!-- Botões de pagamento -->
                <v-row class="mt-3">
                  <v-col
                    v-if="item.points > 0"
                    :cols="item.value > 0 ? '6' : '12'"
                  >
                    <div
                      class="fake-border pointColor"
                      :class="{
                        transparence:
                          _totalPoints > _user?.profile?.points ||
                          loading.submit,
                      }"
                    >
                      <v-card
                        class="card pa-2"
                        color="neutral3"
                        :disabled="
                          loading.submit ||
                          _totalPoints > _user?.profile?.points
                        "
                        @click="createOrder('points')"
                      >
                        <div class="text-center text-body-2 font-weight-bold">
                          <div>Pagar</div>
                          <div>
                            <v-icon class="mr-n1" color="pointColor" small>
                              mdi-cards-diamond
                            </v-icon>

                            {{ _totalPoints }}
                          </div>
                        </div>
                      </v-card>
                    </div>
                  </v-col>

                  <v-col
                    :cols="item.points > 0 ? '6' : '12'"
                    v-if="item.value > 0"
                  >
                    <div
                      class="fake-border primary"
                      :class="{
                        transparence:
                          (_finalPrice > 0 ? _finalPrice < 5 : false) ||
                          loading.submit,
                      }"
                    >
                      <v-card
                        class="card pa-2 text-center"
                        color="neutral3"
                        :disabled="
                          (_finalPrice > 0 ? _finalPrice < 5 : false) ||
                          loading.submit
                        "
                        @click="createOrder('money')"
                      >
                        <div class="text-center text-body-2 font-weight-bold">
                          <div>Pagar</div>
                          <div>
                            <span class="currencyColor--text"> R$ </span>
                            {{ currencyMask(_totalPrice) }}
                          </div>
                        </div>
                      </v-card>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-window-item>

          <v-window-item :value="2" class="pa-0">
            <loader v-if="loading.submit" />

            <div v-else-if="payment" class="pb-4">
              <div class="text-body-1 font-weight-bold text-center mb-2">
                Valor do pagamento
                <span class="primary--text text-h6">
                  R$ {{ currencyMask(_finalPrice) }}
                </span>
              </div>

              <div class="text-body-1 text-center neutral8--text mb-4">
                Escaneie o QR Code abaixo com o aplicativo do seu banco ou
                carteira, efetue o pagamento e aguarde a aprovação da transação.
              </div>

              <v-row class="mb-4" justify="center" no-gutters>
                <v-col cols="auto">
                  <v-card class="pa-2 rounded-lg" color="white">
                    <qrcode-vue :text="payment.code" :size="200" />
                  </v-card>
                </v-col>
              </v-row>

              <div class="mb-4 d-flex flex-column flex-md-row align-center">
                <input
                  v-model="payment.code"
                  id="code"
                  class="code-input pa-2 mr-md-4 mb-2 mb-md-0"
                  readonly
                  dark
                  @focus="copyCode()"
                />

                <v-btn
                  class="btn"
                  color="neutral5"
                  outlined
                  @click="copyCode()"
                >
                  <v-icon color="primary" left>mdi-content-copy</v-icon>

                  <span class="text1--text"> Copiar </span>
                </v-btn>
              </div>

              <div class="text-caption neutral8--text text-center mb-4">
                O valor desta transação será adicionado ao saldo da sua conta
                para ser utilizado na compra. Em caso de dúvidas ou problemas,
                entre em contato com o suporte.
              </div>

              <div class="d-flex align-center justify-center">
                <v-btn class="btn" color="primary" small @click="iPaid()">
                  Já fiz o pagamento
                </v-btn>
              </div>
            </div>
          </v-window-item>

          <v-window-item :value="3" class="pa-0">
            <div class="text-body-1 font-weight-bold mb-4">
              Estamos quase lá! Validando seu pagamento, aguarde um instante...
            </div>

            <div class="d-flex align-center justify-center mb-4">
              <loader v-if="loading.payment" />
            </div>

            <div class="text-body-2 mb-4">
              Se já realizou o pagamento, fique tranquilo, tudo está sendo
              processado com segurança, aguarde até a confirmação do seu pedido.
            </div>

            <div class="text-caption neutral8--text">
              Precisa de ajuda? Contate o
              <span class="font-weight-bold">suporte</span> através do chat no
              canto inferior direito
            </div>
          </v-window-item>
        </v-window>

        <CustomDialog
          v-model="dialogClose"
          ref="customCloseDialog"
          title="Deseja realmente sair?"
          width="600"
          :footerButtons="[
            {
              label: 'Voltar',
              color: 'text1',
              plain: true,
              action: 'cancel',
            },
            {
              label: 'Fechar assim mesmo',
              textClass: 'white--text',
              color: 'error',
              action: 'confirm',
            },
          ]"
          @cancel="dialogClose = false"
          @confirm="close(false)"
        >
          Para garantir que o pagamento seja
          <span class="font-weight-bold">processado</span> com sucesso,
          recomendamos que permaneça nesta tela até a
          <span class="font-weight-bold">finalização</span>. <br />

          Se ainda assim desejar sair, clique em “Fechar assim mesmo”.
        </CustomDialog>

        <CustomDialog
          v-model="dialogPromotion"
          ref="customPromotionDialog"
          :title="`🎉 Promoção Imperdível!`"
          width="600"
          @cancel="dialogPromotion = false"
          @submit="addPromotion(item)"
        >
          <div v-if="dialogPromotion" class="text-body-1">
            <p>
              🚀 Aproveite esta oferta exclusiva e garanta mais vantagens
              enquanto durar!
            </p>

            <p class="left-border pl-3">
              Ao comprar <strong>x{{ promotions[0].trigger }}</strong
              >, você recebe<br />
              <strong>{{ promotions[0].rewardString }}</strong> totalmente
              <span class="text-success">GRÁTIS!</span>
            </p>

            <p>
              Deseja adicionar
              <strong>{{ promotions[0].trigger }}</strong> unidades e aproveitar
              essa promoção agora?
            </p>
          </div>
        </CustomDialog>

        <DrawRarityDialog ref="drawRarityDialog" />
      </div>
    </CustomDialog>

    <loader-overlay v-model="loading.overlay" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getPayment } from "@/services/payments";
import { createOrder, getOrder } from "@/services/orders";
import { getTokensRequests } from "@/services/raffles";
import { sendEvent } from "@/services/sellflux";
import { getPromotionsAvailable } from "@/services/promotions";
import { currencyMask, formatAmount, preventOnlyNumber } from "@/helpers";
import CustomDialog from "@/components/customDialog/CustomDialog";
import DrawRarityDialog from "@/modules/main/partials/drawRarityDialog/DrawRarityDialog.vue";
import QrcodeVue from "vue-qrcode-component";

export default {
  name: "BuyDialog",

  components: {
    CustomDialog,
    DrawRarityDialog,
    QrcodeVue,
  },

  data() {
    return {
      loading: {
        submit: false,
        payment: false,
        overlay: false,
      },
      dialog: false,
      dialogPromotion: false,
      dialogClose: false,
      promotions: [],
      step: 1,
      item: null,
      valid: true,
      quantity: 1,
      suggestions: [5, 10, 15, 20, 50, 100],
      order: null,
      payment: null,
      interval: null,
      messages: {
        payment: {
          failed:
            "O pagamento falhou. Por favor, verifique os dados e tente novamente",
          refused: "O pagamento foi recusado pela operadora, tente novamente",
          refunded:
            "Encontramos um problema! O valor será estornado para a sua conta de origem",
          canceled:
            "O pagamento foi cancelado. Caso tenha ocorrido algum problema, tente novamente",
          expired:
            "O prazo do pagamento expirou. Por favor, efetue uma nova solicitação de pagamento",
        },
        order: {
          rejected: "Saldo insuficiente, tente novamente",
          cancelled:
            "O pagamento foi cancelado. Caso tenha ocorrido algum problema, tente novamente",
          timeout:
            "O prazo do pagamento expirou. Por favor, efetue uma nova solicitação de pagamento",
          error:
            "O pagamento falhou. Por favor, verifique os dados e tente novamente",
        },
      },
    };
  },

  beforeMount() {
    this.$socket.getSocket().on("orders:status", this.updatedOrderStatus);
  },

  beforeDestroy() {
    this.$socket.getSocket().off("orders:status", this.updatedOrderStatus);

    clearInterval(this.interval);
  },

  watch: {
    quantity() {
      this.valid = this.quantity > 0;
    },
  },

  computed: {
    ...mapGetters({ _user: "user", _currentRaffle: "currentRaffle" }),

    _title() {
      if (this.step === 2) return "Aguardando pagamento";
      if (this.step === 3) return "Pagamento informado";

      return "";
    },

    _totalPrice() {
      return this.quantity * this.item.value;
    },

    _totalPoints() {
      return this.quantity * this.item.points;
    },

    _finalPrice() {
      return (
        Math.round((this._totalPrice - this._user?.wallet?.balance) * 100) / 100
      );
    },

    _itemCount() {
      if (!this.item.effects) return 0;

      return this.item.effects.multiplier * this.quantity;
    },
  },

  methods: {
    async createOrder(type = "money") {
      if (!this.valid) return;

      try {
        this.loading.submit = true;

        const payload = {
          items: [{ _id: this.item._id, qty: this.quantity }],
          ...((this.item.itemType === "booster" ||
            this.item.itemType === "points") && {
            autouse: true,
          }),
          ...(this.item.itemType === "booster" && {
            target: "raffles",
            targetID: this._currentRaffle?._id,
          }),
          type: type,
        };

        const { data } = await createOrder(payload);

        this.order = data;

        if (data.payment.paymentID) {
          this.payment = {
            _id: this.order.payment.paymentID,
            status: this.order.status,
          };

          await this.getPayment();
        } else {
          this.iPaid();
        }
      } catch (error) {
        this.$alert(error?.message, "error", {
          subtitle:
            this._finalPrice <= 0
              ? "O valor da transação foi restituído a sua carteira"
              : "",
        });
      } finally {
        this.loading.submit = false;
      }
    },

    async getPayment() {
      try {
        const { data } = await getPayment(this.payment?._id);

        this.step = 2;
        this.payment = data;

        if (data.status === "processing") return;

        if (data.status === "completed") return this.getOrder();

        throw new Error(this.messages.payment[data.status]);
      } catch (error) {
        this.$alert(error?.message, "error");
        this.close();
      }
    },

    async getTokensRequests() {
      try {
        const payload = {
          sourceID: this.order._id,
          source: "orders",
          status: "completed",
        };

        const { data } = await getTokensRequests(payload);

        if (!data.length) return;

        clearInterval(this.interval);

        this.$alert("item comprado com sucesso", "success");
        this.$emit("success:booster", data[0]);

        this.$root.$emit("load-session");
        this.close();
      } catch (error) {
        this.$alert(error?.message, "error");
      }
    },

    async updatedOrderStatus(event) {
      if (!this.order) return;

      try {
        if (event.status === "awaiting" || event.status === "pending") return;

        if (event.status === "approved") {
          this.loading.payment = true;
          this.step = 3;

          return this.getOrder();
        }

        throw new Error(this.messages.order[event.status]);
      } catch (error) {
        this.$alert(error?.message, "error");
        this.close();
      }
    },

    async getOrder() {
      try {
        const { data } = await getOrder(this.order?._id);

        this.order = data;

        if (data?.status === "approved") {
          if (data.autouse && data.autouseError) {
            throw new Error(
              data.autouseErrorMessage ||
                "Falha ao utilizar item, seu item voltou para o seu inventário"
            );
          }

          if (this.item.itemType === "booster")
            return this.handlePurchasedPolling();

          if (this.item.itemType === "draw" || this.item.itemType === "product")
            this.$emit(`success:${this.item.itemType}`, data.items[0]);

          this.$alert("item comprado com sucesso", "success");
          this.$root.$emit("load-session");

          this.close();
        }
      } catch (error) {
        this.$alert(error?.message, "error");
        this.$root.$emit("load-session");
        this.close();
      }
    },

    async sendEvent() {
      try {
        const payload = {
          tags: ["abandonou-carrinho"],
        };

        await sendEvent(payload);
      } catch {
        // ignore
      }
    },

    async getPromotionsAvailable() {
      try {
        this.loading.overlay = true;

        const payload = {
          itemID: this.item._id,
          triggerType: "purchase",
        };

        const { data } = await getPromotionsAvailable(payload);

        if (!data.length) {
          this.loading.overlay = false;
          return;
        }

        this.promotions = data.map((el) => {
          const rewards = el.rewards.map((el) => ({
            _id: el.item._id,
            name: el.item.name,
            qty: el.item.qty,
          }));

          const same = rewards.find((el) => el._id === this.item._id);
          const trigger = el.triggers[0].conditions.item.qty;

          return {
            description: el.description,
            same: !!same,
            trigger: trigger,
            rewards: rewards,
            rewardString: rewards.map((r) => `+${r.qty} ${r.name}`).join(", "),
            off: same
              ? formatAmount((this.item.value * trigger, 2) / same.qty)
              : 0,
          };
        });

        this.dialogPromotion = true;
        this.loading.overlay = false;
      } catch (error) {
        console.log(error);
      }
    },

    handlePurchasedPolling() {
      if (!this.order) return;

      if (this.interval) clearInterval(this.interval);

      this.interval = setInterval(() => {
        this.getTokensRequests();
      }, 5000);
    },

    copyCode() {
      navigator.clipboard.writeText(this.payment.code);
      this.$alert("Copiado para área de transferência", "info");
    },

    decrease() {
      if (this.quantity === 1) return;

      this.quantity--;
    },

    increase() {
      this.quantity++;
    },

    handleRarityDialog() {
      this.$refs.drawRarityDialog.open(this.item);
    },

    open(data) {
      this.item = data;
      this.step = 1;
      this.getPromotionsAvailable();

      this.dialog = true;
    },

    handleCloseDialog() {
      if (this.step === 1) return this.abort();

      this.dialogClose = true;
    },

    close(reset = true) {
      this.dialog = false;
      this.dialogClose = false;

      if (!reset) return;

      this.promotions = [];
      this.step = 1;
      this.item = null;
      this.quantity = 1;
      this.valid = true;
      this.order = null;
      this.payment = null;
      this.loading.payment = false;

      clearInterval(this.interval);
    },

    abort() {
      this.sendEvent();
      this.close();
    },

    setSuggestion(value) {
      this.quantity += value;
    },

    iPaid() {
      this.loading.payment = true;
      this.step = 3;
    },

    addPromotion() {
      this.quantity = this.promotions[0].trigger;
      this.dialogPromotion = false;
    },

    currencyMask,

    formatAmount,

    preventOnlyNumber,
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
